import angular from 'angular';
import template from './template.html';

export const NotificationPlaceholder = function (NotificationService) {
    const ctrl = this;

    ctrl.messages = [];

    NotificationService.registerPlaceholder(ctrl);

    ctrl.addMessage = (message) => {
        if (ctrl.messages.find(existingMessage => existingMessage === message)) {
            throw new Error(`Notification '${message.text}' already shown`);
        }

        ctrl.messages.push(message);
    };

    ctrl.closeMessage = (message) => {
        const messageIndex = ctrl.messages.findIndex(existingMessage => existingMessage === message);

        if (messageIndex > -1) {
            ctrl.messages.splice(messageIndex, 1);
        } else {
            throw new Error(`Notification '${message.text}' not shown`);
        }
    };
};

export const NotificationPlaceholderConfiguration = {
    template,
    controller: NotificationPlaceholder,
    controllerAs: 'notificationPlaceholderCtrl',
};

angular.module('TALENYA-FE').component('notificationPlaceholder', NotificationPlaceholderConfiguration);
